import React from "react";

export default () => <iframe src='about:blank' className="sqftcalc-window" scrolling="no" allowFullScreen name="sqftcalc" width="100%" height="100%" frameBorder="0"/>;




// WEBPACK FOOTER //
// ./src/components/squareFootCalculatorView.js